namespace RioERP {
    export interface ExcelImportResponse extends Serenity.ServiceResponse {
        Inserted?: number;
        Updated?: number;
        CustomerEmail1?: string;
        CustomerEmail2?: string;
        CustomerMobile1?: string;
        CustomerMobile2?: string;
        CustomerName?: string;
        ShippingAddress1?: string;
        Address?: string;
        TrackingURL?: string;
        ShippingAddress2?: string;
        GSTIN?: string;
        Pincode?: string;
        City?: string;
        State?: number;
        Country?: string;
        BillingAddress1?: string;
        BillingAddress2?: string;
        BillingGSTIN?: string;
        BillingPincode?: string;
        BillingCity?: string;
        BillingState?: number;
        TotalItemRate?: number;
        HasBooks?: boolean;
        HasPendrives?: boolean;
        HasCourier?: boolean;
        IsLive?: boolean;
        DownloadUrl1?: string;
        DownloadUrl2?: string;
        InvoiceCompanyId?: number;
        EOpens?: number;
        EWatchTime?: number;
        EValidity?: number;
        EValidityType?: number;
        ValidTill?: string;
        TotalAllowedDuration?: number;
        AllowedDevice?: RioERP.Masters.AllowedDevicesRow[];
        EAccessStatus?: number;
        cost?: number;
        Amount?: number;
        ErrorList?: string[];
    }
}
